export default __webpack_public_path__ + "static/media/left-sep.e93fe80d.svg";